import {EvkHttpService, EvkOption, EvkResponseType} from "@evomatik/evk-common";
import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class ExpedientesConsultasService {

    constructor(
        public http: EvkHttpService
    ) {
    }

    public getExpedienteConfig() {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-expedientes-service/configuracion-expediente/options`).pipe(
            map(response => response.data)
        );
    }

    public getGeoreferenciasDeExpedientes(idConfiguracionExpediente: String) {
        return this.http.get<EvkResponseType<any>>(`/seaged-expedientes-service/expediente/georeferencias/${idConfiguracionExpediente}`).pipe(
            map(response => response.data)
        );
    }

    public getExpediente(idExpediente){
        return this.http.get<EvkResponseType<any>>(`/seaged-expedientes-service/expediente/${idExpediente}`).pipe(
            map(response => response.data)
        );
    }
    public getIndiciosByExpediente(idExpediente){
        return this.http.get<any>(`/seaged-desaparecidas-service/indicio-persona-desaparecida/by-idExpediente/${idExpediente}`).pipe(
            map(response => response)
        );
    }
}
